import { useRegisterSW } from 'virtual:pwa-register/react';

export const SERVICE_WORKER_REFRESH_INTERVAL = 10 * 60 * 1000;

export function useServiceWorkerUpdate() {
    const {
        needRefresh: [needRefresh],
        offlineReady: [offlineReady],
        updateServiceWorker,
    } = useRegisterSW({
        onRegisteredSW(swUrl, registration) {
            registration &&
                setInterval(async () => {
                    if (registration.installing || !navigator) return;

                    if ('connection' in navigator && !navigator.onLine) return;

                    const resp = await fetch(swUrl, {
                        cache: 'no-store',
                        headers: {
                            cache: 'no-store',
                            'cache-control': 'no-cache',
                        },
                    });

                    if (resp?.status === 200) {
                        await registration.update();
                    }
                }, SERVICE_WORKER_REFRESH_INTERVAL);
        },
    });

    return {
        needRefresh,
        offlineReady,
        updateServiceWorker,
    };
}
